import React from 'react'
import '../styles/MyApps_BasePage.css'
import { useTranslation } from 'react-i18next';

const BasePage = () => {
  const { t } = useTranslation();
  return (
    <div id='basepagecontainer'>
      <div className='empty-state-eyebrow'>{t('subscriptionsManagement')}</div>
      <img id="picture" alt={t('noSubscriptions')} src="defaultCommunication.svg" />
      <h3 id="message">{t('noSubscriptions')}</h3>
      <label id='basepagecopy'>{t('noSubscriptionsCopy')}</label>
    </div>
  )
}

export default BasePage
